import { render, staticRenderFns } from "./AdditionalManager.vue?vue&type=template&id=a526e3e2&scoped=true"
import script from "./AdditionalManager.vue?vue&type=script&lang=js"
export * from "./AdditionalManager.vue?vue&type=script&lang=js"
import style0 from "./AdditionalManager.vue?vue&type=style&index=0&id=a526e3e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a526e3e2",
  null
  
)

export default component.exports